import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminPartnerStatsQuery.ts
var r = (r, i) => t({
	queryKey: e.stats(r, i),
	queryFn: () => n.stats(r, i),
	enabled: !!r
});
//#endregion
export { r as useAdminPartnerStatsQuery };
